import { QueryObserverOptions, useQuery } from 'react-query';

import getRoi, { GetRoiInput, GetRoiOutput } from 'clients/api/queries/getRoi';
import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';


type Options = QueryObserverOptions<
    GetRoiOutput,
    Error,
    GetRoiOutput,
    GetRoiOutput,
    [FunctionKey.GET_ROI, string]
>;

const useGetRoi = (
    { accountAddress }: Omit<GetRoiInput, 'dlVaultContract'>,
    options?: Options,
) => {
    const dlVaultContract = useDlVaultContract();
    return useQuery(
        [FunctionKey.GET_ROI, accountAddress],
        () =>
            getRoi({
                dlVaultContract,
                accountAddress,
            }),
        options,
    );
};

export default useGetRoi;
